function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16 12.3816V18.3816M16 20.3816V20.3016M15.15 6.23638L4.64996 22.8964C4.56356 23.0656 4.52247 23.2543 4.53069 23.4441C4.53891 23.634 4.59616 23.8184 4.69687 23.9796C4.79757 24.1407 4.93829 24.273 5.10532 24.3636C5.27235 24.4541 5.45999 24.4999 5.64996 24.4964H26.1C26.3251 24.4973 26.5466 24.4402 26.7432 24.3306C26.9399 24.221 27.1049 24.0626 27.2225 23.8707C27.3401 23.6787 27.4062 23.4597 27.4146 23.2347C27.4229 23.0098 27.3731 22.7865 27.27 22.5864L16.86 6.23638C16.7708 6.08943 16.6453 5.96794 16.4956 5.88362C16.3458 5.7993 16.1768 5.755 16.005 5.755C15.8331 5.755 15.6641 5.7993 15.5144 5.88362C15.3646 5.96794 15.2391 6.08943 15.15 6.23638Z",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.cf80149c.svg";
export { ForwardRef as ReactComponent };